export type Player = {
  readonly name: string;
  readonly avatar: string;
  readonly total: number;
  /** Not sent by the current API — kept optional in case it returns. */
  readonly steam?: string;
};

type PlayersResponse = {
  success: boolean;
  players?: unknown;
};

const PLAYERS_ENDPOINT = import.meta.env.VITE_PLAYERS_API_URL ?? "https://fivemapi.offsdev.com/sorteio/players";

function isPlayer(value: unknown): value is Player {
  if (typeof value !== "object" || value === null) return false;

  const candidate = value as Record<string, unknown>;

  return typeof candidate.name === "string" && typeof candidate.avatar === "string" && typeof candidate.total === "number";
}

/**
 * Fetches the ticket leaderboard. Unknown/partial records are dropped rather
 * than trusted, because the response is rendered straight into the DOM.
 */
export async function fetchPlayers(signal?: AbortSignal): Promise<readonly Player[]> {
  const response = await fetch(PLAYERS_ENDPOINT, {
    headers: { Accept: "application/json" },
    ...(signal ? { signal } : {}),
  });

  if (!response.ok) {
    throw new Error(`Players request failed with status ${response.status}`);
  }

  const body = (await response.json()) as PlayersResponse;

  if (!body.success || !Array.isArray(body.players)) {
    throw new Error("Players request returned an unsuccessful payload");
  }

  return body.players.filter(isPlayer);
}
